//Spinner.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as MainMap from "../MainMap";

import { CircularProgress } from "@mui/material";

import React from "react";

export let show: (useCursor?: boolean) => void; //Ref to showIt method inside render.
export let hide: () => void; //Ref to hideIt method inside render.
export let busy: boolean = false;
let cursorMode: boolean = false;

export function Render() {
   //Util.logMsg("Top of Spinner Render");
   const [visible, setVisible] = React.useState(false); //Set refresh method.

   function showIt(useCursor: boolean) {
      busy = true;
      if (useCursor) {
         cursorMode = true;
         MainMap.activeViewDiv.style.cursor = "wait";

      } else {
         cursorMode = false;
         setVisible(true);  //Show spinner.
      }
   }
   function hideIt() {
      if (cursorMode) {
         MainMap.activeViewDiv.style.cursor = "default";
      } else {
         setVisible(false); //Hide spinner.
      }
      busy = false;
   }

   const showRef = React.useRef(showIt);
   const hideRef = React.useRef(hideIt);

   //Component did mount.
   React.useEffect(() => {
      show = showRef.current;
      hide = hideRef.current;
   }, []);

   const styles: Default.iStyles = {
      div: { backgroundColor: "rgba(207, 216, 220, 0.90)", padding: 5, borderRadius: 4, position: 'absolute', top: '40%', left: '48%', zIndex: 9999 },
   };

   return (
      <div>
         {visible &&
            <div style={styles.div}>
               <CircularProgress color='primary' size={30} thickness={3.6} />
            </div>
         }
      </div>
   ); //end return.
} //end function.
